@use '../styles/typography' as *;

.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 11px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: var(--chartv2-chip-surface, var(--surface-default, transparent));
  color: var(--chartv2-foreground, var(--text-default, #202020));
  @include body-sm;
  cursor: pointer;
  outline: none;
  transition: background-color 120ms ease, color 120ms ease,
    border-color 120ms ease;
  font-family: inherit;
  white-space: nowrap;
}

.chip.upper {
  text-transform: uppercase;
}

.chip:not(.active):hover {
  background: var(
    --chartv2-chip-hover,
    var(--surface-hover, rgba(0, 0, 0, 6%))
  );
}

.chip:focus-visible {
  outline: 2px solid
    var(--chartv2-focus, var(--border-focus, rgba(0, 144, 255, 60%)));
  outline-offset: 1px;
}

.chip.active {
  background: transparent;
  color: var(--chartv2-primary, var(--text-primary, #0090ff));
  border-color: var(--chartv2-primary, var(--border-primary, #0090ff));
}

.chip.disabled {
  background: transparent;
  color: var(--surface-neutral, rgba(0, 0, 0, 30%));
  cursor: not-allowed;
  pointer-events: none;
}

.icon {
  display: inline-flex;
  width: 14px;
  height: 14px;
  align-items: center;
  justify-content: center;
}
